<div class="space-y-6 [@media(max-height:712px)]:space-y-4 bg-slate-50 dark:bg-slate-900 p-6 ">

  <!-- ───────────────── Header ─────────────────────────────────────────────── -->
  <header class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
    <h1
      class="text-[20px] font-bold text-[#0e1b2e] dark:text-white tracking-[-0.4px] font-['Lato',-apple-system,BlinkMacSystemFont,sans-serif] whitespace-nowrap">
      Training &amp; Conversion</h1>
    <div class="flex flex-wrap items-center gap-2 justify-end">
      <app-date-picker [size]="'md'" (dateRangeChange)="onDateRangeChange($event)" [showComparison]="true"
        [showGroupBy]="true" [allowedGroupByUnits]="allowedGroupByUnits">
      </app-date-picker>
    </div>
  </header>

  <!-- ─────────────── Training KPI Cards ───────────────────────────────────── -->
  <section class="mb-[30px] relative">
    @if (isStatsLoading() || isPostJourneyLoading() || isAdminTableLoading()) {
    <app-individual-toaster></app-individual-toaster>
    }
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">

      <!-- Completion Rate -->
      <div
        class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-[17px_18px_16px] shadow-sm relative">
        <div class="flex items-center justify-between mb-[11px]">
          <span class="text-[11px] font-[600] tracking-[0.3px] uppercase text-[#6a7c93] dark:text-slate-400">Completion
            Rate</span>
          <span class="text-[9.5px] font-bold px-2 py-1 rounded-full"
            [ngClass]="kpis().completionMoM! > 0 ? 'bg-slate-100 text-slate-600' : (kpis().completionMoM == null || kpis().completionMoM! == 0) ? 'bg-emerald-100 text-emerald-500' : 'bg-purple-100 text-purple-700' ">{{
            kpis().completionMoM! > 0 ?
            'LEADING' : (kpis().completionMoM == null || kpis().completionMoM! == 0) ? 'STABLE' : 'LAGGING' }}</span>
        </div>
        <div
          class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-0">
          {{ formatPercent(kpis().completionRate) }}
        </div>
        <p class="mt-[7px] text-[11.5px] text-[#6a7c93] dark:text-slate-400 leading-[1.45]">
          {{ formatNumber(kpis().totalCompletedSessions) }} completed of
          {{ formatNumber(kpis().totalBookedSessions) }} ·
          {{ formatNumber(kpis().totalNotInterestedSessions) }} not interested ·
          {{ formatNumber(kpis().totalCancelledSessions) }} cancelled
        </p>
        <div class="mt-[4px] flex items-center gap-[7px] text-[11px] font-[500]"
          [class]="kpis().completionMoM! > 0 ? 'text-emerald-500' : kpis().completionMoM! < 0 ? 'text-red-500' : 'text-orange-400'">
          <span class="h-2 w-2 rounded-full"
            [ngClass]="kpis().completionMoM! > 0 ? 'bg-emerald-500' : kpis().completionMoM! < 0 ? 'bg-red-500' : 'bg-orange-400'"></span>
          MoM {{ formatMoM(kpis().completionMoM) || '0' }}
        </div>
      </div>

      <!-- Session Waste -->
      <div
        class="bg-gradient-to-r from-red-50 to-white dark:from-red-900/10 dark:to-slate-800 rounded-xl border border-red-300 dark:border-red-500/40 p-[17px_18px_16px] shadow-sm relative overflow-hidden before:absolute before:inset-y-0 before:left-0 before:w-[4px] before:bg-red-600">
        <div class="flex items-center justify-between mb-[11px]">
          <span class="text-[11px] font-[600] tracking-[0.3px] uppercase text-[#6a7c93] dark:text-slate-400">Session
            Waste</span>
          <span
            class="text-[10px] font-bold uppercase tracking-wider bg-amber-50 text-amber-600 dark:bg-amber-500/10 dark:text-amber-400 px-2.5 py-1 rounded-full">Critical</span>
        </div>
        <div
          class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-0">
          {{ formatPercent(kpis().sessionWasteRate) }}
        </div>
        <p class="mt-[7px] text-[11.5px] text-[#6a7c93] dark:text-slate-400 leading-[1.45]">
          No-show {{ formatPercent(kpis().noShowRate) }} ({{ formatNumber(kpis().totalNoShowSessions) }}) ·
          cancellation {{ formatPercent(kpis().cancelledRate) }} ({{ formatNumber(kpis().totalCancelledSessions) }})
        </p>
        <div class="mt-[4px] flex items-center gap-[7px] text-[11px] font-[500]"
          [class]="kpis().wasteMoM !== null ? momClass(kpis().wasteMoM, true) : 'text-red-500'">
          <span class="h-2 w-2 rounded-full"
            [class]="kpis().wasteMoM !== null ? momDotClass(kpis().wasteMoM, true) : 'bg-red-500'"></span>
          MoM {{ formatMoM(kpis().wasteMoM) || 0 }}
        </div>
      </div>

      <!-- Post-Training Contract Rate -->
      <div
        class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-[17px_18px_16px] shadow-sm relative">
        <div class="flex items-center justify-between mb-[11px]">
          <span
            class="text-[11px] font-[600] tracking-[0.3px] uppercase text-[#6a7c93] dark:text-slate-400">Post-Training
            Contract Rate</span>
          <span class="text-[9.5px] font-bold px-2 py-1 rounded-full"
            [ngClass]="kpis().postContractMoM! > 0 ? 'bg-slate-100 text-slate-600' : (kpis().postContractMoM == null || kpis().postContractMoM! == 0) ?  'bg-emerald-100 text-emerald-500' : 'bg-purple-100 text-purple-700' ">{{
            kpis().postContractMoM! > 0 ?
            'LEADING' : (kpis().postContractMoM == null || kpis().postContractMoM! == 0) ? 'STABLE' : 'LAGGING'
            }}</span>
        </div>
        <div
          class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-0">
          {{ formatPercent(kpis().postTrainingContractRate) }}
        </div>
        <p class="mt-[7px] text-[11.5px] text-[#6a7c93] dark:text-slate-400 leading-[1.45]">
          Of trained businesses that create a first contract.
        </p>
        <div class="mt-[4px] flex items-center gap-[7px] text-[11px] font-[500]"
          [class]="kpis().postContractMoM! > 0 ? 'text-emerald-500' : kpis().postContractMoM! < 0 ? 'text-red-500' : 'text-orange-400'">
          <span class="h-2 w-2 rounded-full"
            [ngClass]="kpis().postContractMoM! > 0 ? 'bg-emerald-500' : kpis().postContractMoM! < 0 ? 'bg-red-500' : 'bg-orange-400'"></span>
          MoM {{ formatMoM(kpis().postContractMoM) || 0 }}
        </div>
      </div>
    </div>
  </section>

  <!-- ─────────────── Training Decisions ──────────────────────────────────── -->
  <section class="mb-[30px] relative">
    @if (isStatsLoading() || isUnregLoading() || isTimeToContractLoading()) {
    <app-individual-toaster></app-individual-toaster>
    }
    <h2
      class="text-[20px] font-bold text-[#0e1b2e] dark:text-white tracking-[-0.4px] font-['Lato',-apple-system,BlinkMacSystemFont,sans-serif] mb-[14px]">
      Training Decisions</h2>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">

      <!-- Capacity Leak -->
      <article
        class="relative overflow-hidden bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-[18px_18px_16px_22px] shadow-sm flex flex-col before:absolute before:inset-y-0 before:left-0 before:w-[4px] before:bg-red-600 transition-all duration-150 hover:shadow-md hover:-translate-y-[2px]">
        <div
          class="flex items-center gap-2 text-[10.5px] font-[700] uppercase tracking-[0.7px] text-red-600 dark:text-red-500 mb-[11px]">
          <span class="h-[9px] w-[9px] rounded-[3px] bg-red-600 shrink-0"></span>
          Capacity Leak
        </div>
        <p class="text-[14.5px] font-[500] text-[#0e1b2e] dark:text-white leading-[1.5] mb-[13px]">
          <strong>{{ formatPercent(decision().capacityLeakRate) }}</strong> no-show rate —
          <strong>{{ formatNumber(decision().capacityLeakSessions) }}</strong> sessions lost.
        </p>
        <hr class="mt-0 mb-[12px] border-t border-dashed border-slate-200 dark:border-slate-700">
        <div class="text-[9.5px] font-[700] uppercase tracking-[0.7px] text-[#6a7c93] dark:text-slate-400 mb-[5px]">
          Action</div>
        <p class="text-[12.5px] leading-[1.5] text-[#3b4d64] dark:text-slate-300 mb-[14px]">
          Mandate a <strong class="text-[#0e1b2e] font-[700] dark:text-white">24-hour</strong> reminder + 1-click
          reschedule; cap advance booking at <strong class="text-[#0e1b2e] font-[700] dark:text-white">7 days</strong>.
        </p>
        <!-- <div
          class="mt-auto rounded-lg bg-red-50 dark:bg-red-900/20 p-[10px_13px] text-[12px] font-[600] text-red-600 dark:text-red-400 leading-[1.45]">
          Recover <b class="font-['Lato',-apple-system,BlinkMacSystemFont,sans-serif] font-[700]">10%</b> of no-shows ≈
          <b class="font-['Lato',-apple-system,BlinkMacSystemFont,sans-serif] font-[700]">+{{
            formatNumber(recoverableContracts) }}</b> contracts / year.
        </div> -->
      </article>

      <!-- Unregistered Gap -->
      <article
        class="relative overflow-hidden bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-[18px_18px_16px_22px] shadow-sm flex flex-col before:absolute before:inset-y-0 before:left-0 before:w-[4px] before:bg-[#d97706] transition-all duration-150 hover:shadow-md hover:-translate-y-[2px]">
        <div
          class="flex items-center gap-2 text-[10.5px] font-[700] uppercase tracking-[0.7px] text-[#d97706] dark:text-[#d97706] mb-[11px]">
          <span class="h-[9px] w-[9px] rounded-[3px] bg-[#d97706] shrink-0"></span>
          Unregistered Gap
        </div>
        <p class="text-[14.5px] font-[500] text-[#0e1b2e] dark:text-white leading-[1.5] mb-[13px]">
          <strong>{{ formatPercent(decision().unregisteredPercent, 0) }}</strong> never convert —
          <strong>{{ formatNumber(decision().unregisteredUnconvertedCount) }}</strong> of
          <strong>{{ formatNumber(decision().unregisteredTotal) }}</strong> unregistered bookings.
        </p>
        <hr class="mt-0 mb-[12px] border-t border-dashed border-slate-200 dark:border-slate-700">
        <div class="text-[9.5px] font-[700] uppercase tracking-[0.7px] text-[#6a7c93] dark:text-slate-400 mb-[5px]">
          Action</div>
        <p class="text-[12.5px] leading-[1.5] text-[#3b4d64] dark:text-slate-300 mb-[14px]">
          Launch a <strong class="text-[#0e1b2e] font-[700] dark:text-white">48-hour</strong> post-session nurture for
          the unregistered cohort.
        </p>
        <!-- <div
          class="mt-auto rounded-lg bg-orange-50 dark:bg-orange-900/20 p-[10px_13px] text-[12px] font-[600] text-orange-700 dark:text-orange-400 leading-[1.45]">
          <b class="font-['Lato',-apple-system,BlinkMacSystemFont,sans-serif] font-[700]">{{
            formatNumber(decision().highIntentConvertedCount) }}</b> high-intent conversions already proven — scale the
          sequence.
        </div> -->
      </article>

      <!-- Activation Sprint -->
      <article
        class="relative overflow-hidden bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-[18px_18px_16px_22px] shadow-sm flex flex-col before:absolute before:inset-y-0 before:left-0 before:w-[4px] before:bg-[#00a850] transition-all duration-150 hover:shadow-md hover:-translate-y-[2px]">
        <div
          class="flex items-center gap-2 text-[10.5px] font-[700] uppercase tracking-[0.7px] text-[#00a850] dark:text-[#00a850] mb-[11px]">
          <span class="h-[9px] w-[9px] rounded-[3px] bg-[#00a850] shrink-0"></span>
          Activation Sprint
        </div>
        @if (isFm) {
        <p class="text-[14.5px] font-[500] text-[#0e1b2e] dark:text-white leading-[1.5] mb-[13px]">
          <strong>{{ decision().distribution?.[0]?.percent_share || '0' }}%</strong> of post-training conversions happen
          within <strong>7 days</strong>.
        </p>
        } @else {
        <p class="text-[14.5px] font-[500] text-[#0e1b2e] dark:text-white leading-[1.5] mb-[13px]">
          <strong>{{ formatPercent(decision().activationPercent, 0) }}</strong> of post-training conversions happen
          within <strong>7 days</strong>.
        </p>
        }
        <hr class="mt-0 mb-[12px] border-t border-dashed border-slate-200 dark:border-slate-700">
        <div class="text-[9.5px] font-[700] uppercase tracking-[0.7px] text-[#6a7c93] dark:text-slate-400 mb-[5px]">
          Action</div>
        <p class="text-[12.5px] leading-[1.5] text-[#3b4d64] dark:text-slate-300 mb-[14px]">
          Drop a guided onboarding checklist into the <strong
            class="text-[#0e1b2e] font-[700] dark:text-white">7-days</strong> post-training window.
        </p>
        <!-- <div
          class="mt-auto rounded-lg bg-[#eefaf3] dark:bg-[#00a850]/20 p-[10px_13px] text-[12px] font-[600] text-[#00a850] dark:text-[#00a850] leading-[1.45]">
          Activation <b class="font-['Lato',-apple-system,BlinkMacSystemFont,sans-serif] font-[700]">32% → 43%+</b> ≈ <b
            class="font-['Lato',-apple-system,BlinkMacSystemFont,sans-serif] font-[700]">+{{
            formatNumber(activationSprintUpsideContracts) }}</b> contracts / year.
        </div> -->
      </article>
    </div>
  </section>
  <!-- Activation blockers -->
  <section class="mb-[30px]">
    <h2
      class="text-[20px] font-bold text-[#0e1b2e] dark:text-white tracking-[-0.4px] font-['Lato',-apple-system,BlinkMacSystemFont,sans-serif] mb-[14px]">
      Activation blockers
    </h2>

    <div
      class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-[17px_18px] shadow-sm relative flex flex-col">
      @if (isVerificationLoading()) { <app-individual-toaster></app-individual-toaster> }

      <div class="flex justify-between items-start mb-2">
        <span class="text-[11px] font-[600] tracking-[0.3px] uppercase text-[#6a7c93] dark:text-slate-400">
          Verified Customers
        </span>
        <span
          class="text-[9px] font-[700] px-2 py-[2px] rounded-full bg-[#f4effc] text-[#714bca] dark:bg-purple-900/30 dark:text-purple-400 tracking-[0.3px]">
          LOW-TOUCH
        </span>
      </div>

      <div
        class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-[8px]">
        {{ formatNumber(verificationData().count) }}
      </div>

      <p class="text-[11.5px] text-[#6a7c93] dark:text-slate-400 leading-[1.4] m-0">
        <!-- @if (verificationData().subtitle) {
          {{ verificationData().subtitle }}
        } @else { -->
        {{ verificationData().percent }} of customer base verified &middot; scales onboarding without headcount
        <!-- } -->
      </p>
    </div>
  </section>
  <!-- Activation blockers end  -->
  <!-- What's blocking activation -->
  @if (isFm) {
  <section class="mb-[30px]">
    <div
      class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-[17px_18px] shadow-sm relative">
      @if (isBlockingLoading()) { <app-individual-toaster></app-individual-toaster> }

      <h3 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white mb-[2px]">
        What's Blocking Activation
      </h3>
      <p class="text-[11.5px] text-[#6a7c93] dark:text-slate-400 mb-[20px] leading-[1.4]">
        {{ blockingActivationSubtitle }}
      </p>

      <div class="relative w-full">
        @if (blockingActivationData.length > 0) {
        <app-horizontal-bar-chart [data]="blockingActivationData" [minHeight]="260" [showXAxisGrid]="false"
          [showXAxisLabel]="false" [maxBarWidth]="40" [barPadding]="0.3" [roundedCorners]="true" [cornerRadius]="4"
          [marginTop]="5" [leftMargin]="120" [marginBottom]="55" [yAxisLabelColor]="'rgb(100, 116, 139)'"
          [yAxisLabelSize]="'12px'" [maxLabelWidth]="120" [showBarsValue]="true">
        </app-horizontal-bar-chart>
        }
      </div>
    </div>
  </section>
  }
  <!-- What's blocking activation end -->
  <!-- ─────────────── Session Performance ──────────────────────────────────── -->
  <section class="mb-[30px]">
    <h2
      class="text-[20px] font-bold text-[#0e1b2e] dark:text-white tracking-[-0.4px] font-['Lato',-apple-system,BlinkMacSystemFont,sans-serif] mb-[14px]">
      Session Performance</h2>

    <!-- Monthly Training Performance — combo bar + 2 lines -->
    <div
      class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-[17px_18px] shadow-sm mb-[16px] relative">
      @if (isPerformanceLoading()) { <app-individual-toaster></app-individual-toaster> }
      <h3 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white">
        Training Performance Overview</h3>
      <p class="text-[11.5px] text-[#6a7c93] dark:text-slate-400 mt-[3px] mb-[15px] leading-[1.4]">Session Volume vs
        Completion & No-Show Rates
      </p>

      <div class="h-[340px] [@media(max-height:712px)]:h-[280px] relative flex flex-col">
        @if (performanceData.length > 0) {
        <div class="flex-1 relative min-h-0">
          <app-bar-line [data1]="performanceData" [lines]="performanceLines" [legendData]="[]" [hideLegend]="true"
            [colors]="performanceColors" [tooltipData]="performanceTooltip" [valueKey]="'total'" [valueType]="''"
            [rightAxisType]="'percent'" [leftAxisLabel]="''" [rightAxisLabel]="''"
            [margin]="{ top: 20, right: 50, bottom: 25, left: 60 }" [labelKey]="'unit_date'" [showBackground]="false"
            [barTextposition]="'none'" [formatDateXAxis]="true" [unit]="isFm ? 'month' : unit()"
            [xAxisShowOnlyFirstLast]="true">
          </app-bar-line>
        </div>
        <div class="flex-none flex justify-center items-center gap-6 pb-2 pt-2">
          @for (legend of performanceLegend; track legend.key) {
          <div class="flex items-center gap-2 cursor-pointer transition-opacity duration-200"
            [class.opacity-40]="legend.hidden" (click)="onLegendClick(legend)">

            @if (legend.type === 'square') {
            <div class="w-3 h-3" [style.backgroundColor]="legend.color"></div>
            } @else if (legend.type === 'square-outline') {
            <div class="w-3 h-3 border-1" [style.borderColor]="legend.color"></div>
            } @else if (legend.type === 'dashed-square') {
            <div class="w-3 h-3 border-1 border-dashed  bg-slate-300" [style.borderColor]="legend.color">
            </div>
            } @else if (legend.type === 'solid-line') {
            <div class="w-3.5 h-3 flex items-center justify-center relative">
              <div class="w-full border-t-2 border-solid" [style.borderColor]="legend.color"></div>
              <div class="w-1.5  absolute rounded-full" [style.backgroundColor]="legend.color"></div>
            </div>
            } @else if (legend.type === 'dashed-line') {
            <div class="w-3.5 h-3 flex items-center justify-center relative">
              <div class="w-full border-t-2 border-dashed" [style.borderColor]="legend.color"></div>
              <div class="w-1  absolute" [style.backgroundColor]="legend.color"></div>
            </div>
            }

            <span class="text-[12px] font-medium text-[#475569] dark:text-slate-200 font-['Inter',sans-serif]">
              {{ legend.label }}
            </span>
          </div>
          }
        </div>
        } @else {
        <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500 absolute inset-0 w-full">
          <app-icon-v2 name="inbox" [size]="64" class="text-gray-300 mb-4"></app-icon-v2>
          <p class="text-lg font-medium">No data available</p>
          <p class="text-sm mt-1">Data will appear here when available</p>
        </div>
        }
      </div>
    </div>
    @if (!isFm) {
    <!-- Completion by Type + Time to First Contract side by side -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">

      <!-- Completion Rate by Training Type -->
      <div
        class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-[17px_18px] shadow-sm relative">
        @if (isCompletionTypeLoading()) { <app-individual-toaster></app-individual-toaster> }
        <h3 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white">
          Completion Rate By Training Type</h3>
        <p class="text-[11.5px] text-[#6a7c93] dark:text-slate-400 mt-[3px] mb-[15px] leading-[1.4]">Session completion
          % by program type</p>
        <div class="relative" [style.min-height.px]="0">
          @if (completionTypeData.length > 0) {
          <app-horizontal-bar-chart [data]="completionTypeData" [minHeight]="150" [showXAxisGrid]="true"
            [showXAxisLabel]="true" [showYAxisLabel]="true" [showYAxisLine]="false" [colorYAxisLabels]="false"
            [roundedCorners]="true" [cornerRadius]="4" [yAxisTickPadding]="10" [barHeight]="24" [barPadding]="0.3"
            [leftMargin]="150" [maxLabelWidth]="150" [marginTop]="16" [marginBottom]="40" [forceMaxVal]="100"
            valueType="%" class="w-full block">
          </app-horizontal-bar-chart>
          } @else {
          <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500 min-h-[200px] w-full">
            <app-icon-v2 name="inbox" [size]="64" class="text-gray-300 mb-4"></app-icon-v2>
            <p class="text-lg font-medium">No data available</p>
            <p class="text-sm mt-1">Data will appear here when available</p>
          </div>
          }
        </div>
      </div>

      <!-- Time to First Contract Doughnut -->
      <div
        class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-[17px_18px] shadow-sm relative">
        @if (isTimeToContractLoading()) { <app-individual-toaster></app-individual-toaster> }
        <h3 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white">
          Time to First Contract Distribution</h3>
        <!-- @if (decision().activationPercent > 0) { -->
        <p class="text-[11.5px] text-[#6a7c93] dark:text-slate-400 mt-[3px] mb-[15px] leading-[1.4]">{{
          formatPercent(decision().activationPercent, 0) }} of post-training conversions land within 7 days &mdash; size
          the onboarding sprint to this window</p>
        <!-- } -->
        <div class="h-[220px] relative flex items-center justify-center">
          @if (timeToContractDonut.length > 0) {
          <app-donut-chart [data]="timeToContractDonut" [width]="460" [height]="220" [innerRadiusRatio]="0.6"
            [outerRadiusRatio]="1.0" [radiusScale]="1.0" [showLegend]="true" [showLegendValue]="false"
            [showValue]="false" [showPolylines]="false" legendPosition="right" legendShape="circle"
            [expandOnHover]="false">
          </app-donut-chart>
          } @else {
          <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500 absolute inset-0 w-full">
            <app-icon-v2 name="inbox" [size]="64" class="text-gray-300 mb-4"></app-icon-v2>
            <p class="text-lg font-medium">No data available</p>
            <p class="text-sm mt-1">Data will appear here when available</p>
          </div>
          }
        </div>
      </div>
    </div>
    }
  </section>

  <!-- ─────────────── Cohort & Admin Drill-through ───────────────────────── -->
  <div
    class="bg-purple-50/40 dark:bg-purple-900/10 rounded-xl px-4 py-3.5 mb-4 cursor-pointer flex items-center gap-3 transition-colors hover:bg-purple-50 dark:hover:bg-white/10"
    (click)="toggleDrillThrough()">
    <span class="text-purple-700 dark:text-purple-400 font-bold text-lg leading-none w-4 flex justify-center">{{
      isDrillThroughOpen() ? '-' : '+' }}</span>
    <span
      class="text-[#7C3AED] dark:text-purple-400 font-[700] text-[13.5px] font-['Lato',-apple-system,BlinkMacSystemFont,sans-serif]">Cohort
      &amp; Admin Drill-Through</span>
  </div>
  @if (isDrillThroughOpen()) {
  <section class="pb-[30px]">
    <div
      class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-[17px_18px] shadow-sm relative">
      @if (isAdminTableLoading()) { <app-individual-toaster></app-individual-toaster> }
      <div class="flex items-center justify-between mb-4">
        <div>
          <h3 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white">
            Full Admin Conversion Table</h3>
          <p class="text-[11.5px] text-[#6a7c93] dark:text-slate-400 mt-[3px] leading-[1.4]">Complete Overview of All
            Admin Conversions</p>
          <!-- <p class="text-[11.5px] text-[#6a7c93] dark:text-slate-400 mt-[3px] leading-[1.4]">Click a header to sort
            &middot; avg conversion {{ adminAvgConversion() | number:'1.0-0' }}% &middot; Good &ge;20%, Average 13-19%,
            Below &lt;13%</p> -->
        </div>
      </div>
      @if (adminTableData.length > 0) {
      <div class="[&_app-pagination>div>div:first-child]:!hidden [&_app-pagination>div]:!justify-end w-full">
        <app-paginated-table [headers]="adminTableHeaders" [tableData]="adminTableData" [pageSize]="10"
          [paddingYAxis]="'py-3'" [headerClass]="'bg-transparent'" [tableWrapperClass]="'border-none'"
          [hideOuterBorder]="true" [headerBorderClass]="'border-b-2 border-slate-200 dark:border-slate-700'"
          [rowBorderClass]="'border-slate-100 dark:border-slate-800/60'" [headerDefaultBgClass]="'bg-transparent'"
          [headerRoundedClass]="''" [cellPaddingClass]="'py-1.5 px-1 sm:px-2 md:px-3'">
        </app-paginated-table>
      </div>
      } @else {
      <div
        class="flex flex-col items-center justify-center h-full py-12 text-gray-500 min-h-[250px] border border-dashed border-slate-200 dark:border-slate-700 rounded-xl w-full">
        <app-icon-v2 name="inbox" [size]="64" class="text-gray-300 mb-4"></app-icon-v2>
        <p class="text-lg font-medium">No admin conversion data available</p>
        <p class="text-sm mt-1">Data will appear here when available</p>
      </div>
      }
    </div>
  </section>
  }

</div>